const commercial = {
  commercial: {
    pageHeader: 'Commercial Projects',
    pageSubHeading: 'Enphase digital tools and services to create and manage your commercial fleet.',
    contactUsMessage: 'For queries related to Commercial services, please contact',
    contactUsEmail: 'Email',
    contactUsPhone: 'Phone',
    contactUsHelpText: 'Need more help?',
    contactUsRedirectText: 'Click here',
    bomFormTitle: 'BOM Calculator',
    bomFormText: 'Please select any one option to proceed further',
    bomFormNewBomOption: 'Calculate a new Bill of Material (BOM)',
    bomFormExistingBomOption: 'Open/Edit existing Bill of Material (BOM)',
    leadCardTitle: 'My Leads',
    leadCardDesc: 'Create and manage commercial leads',
    systemCardTitle: 'Systems',
    systemCardDesc: 'Create commercial sites and monitor your fleet',
    bomCardTitle: 'BOM Calculator',
    bomCardDesc: 'Estimate BOM (Bill of materials) and project cost',
    solargrafCardTitle: 'Design and proposal tool (Solargraf)',
    solargrafCardDesc: 'Access a comprehensive design and proposal tool',
    resourceCardTitle: 'Resources',
    resourceCardDesc: 'Access resources to learn more about Enphase commercial',
    commResourceTitle: 'Commercial resources',
    commResourceDesc: 'Access all the commercial resources',
    euResourceTitle: 'Enphase University (Training)',
    euResourceDesc: 'Access Enphase curated commercial training',
    mccResourceTitle: 'Module Compatibility Calculator',
    mccResourceDesc: 'Determine module compatibility with Enphase microinverters',
    serviceCardTitle: 'Commercial Services',
    serviceCardDesc: 'Access services for your commercial sites',
    drsServiceTitle: 'Design Review Service',
    drsServiceDesc: 'Get your designs reviewed for commercial sites',
    permitServiceTitle: 'Permit Assistance Service',
    permitServiceDesc: 'Get permit assistance for your commercial sites',
    contactCardTitle: 'Contact us',
    contactCardDesc: 'We are happy to help you at any stage'
  }
};

export default commercial;
